import { Button, Empty, Row } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { LogoIcon } from "../../assets/svg/Svgs";
import { Loader } from "../../components/common/Loader";
import { GuestLayout } from "../../components/layouts/GuestLayout";
import { APP_NAME, BLOG_URL, PROXY_URL } from "../../constants/constants";
import { beautifyText, formatDate } from "../../utils/helperUtils";
import { useNavigate } from "react-router-dom";

export const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getMediumPosts()
      .then((posts) => {
        setPosts(posts);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <GuestLayout>
      <div className="container p20 flexColumn gap20">
        <h2 className="secondary">{APP_NAME} Blog</h2>

        {loading ? (
          <div className="flexCenter">
            <Loader />
          </div>
        ) : posts?.length > 0 ? (
          <GridWrapper className="flexColumn gap20">
            {posts?.map((post) => (
              <PostItem key={post.title} data={post} />
            ))}
          </GridWrapper>
        ) : (
          <div className="flexCenter">
            <Empty description="No posts available" />
          </div>
        )}
      </div>
    </GuestLayout>
  );
};

const PostItem = ({ data }) => {
  const { title, categories, pubDate } = data || {};
  const imageUrl = extractImage(data);
  const excerpt = extractExcerpt(data);
  const date = formatDate(pubDate);
  const navigate = useNavigate();

  return (
    // <a href={link} target="_blank" rel="noopener noreferrer">
    <PostWrapper
      onClick={() => {
        navigate("/blog/post", { state: data });
      }}
    >
      {/* IMAGE */}
      <div className="imageBox r10 lightBg flexCenter relative">
        <img src={LogoIcon} className="absolute" alt={APP_NAME} />
        <img
          className="image animate pointer absolute"
          src={imageUrl}
          alt={title}
        />
      </div>

      {/* TITLE */}
      <h3 className="black">{title}</h3>

      {/* CONTENT */}
      <p className="font14 grey">{excerpt}</p>

      {/* DATE */}
      <div className="font12 grey">{date}</div>

      {/* CATEGORIES */}
      <Row className="gap10">
        {categories?.map((category) => (
          <span
            className="font11 lightBg r15 black"
            style={{ padding: "5px 10px" }}
            key={category}
          >
            {beautifyText(category)}
          </span>
        ))}
      </Row>

      {/* READ MORE */}
      <div>
        <Button type="primary" className="font12">
          Read More
        </Button>
      </div>
    </PostWrapper>
    // </a>
  );
};

const PostWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    &:hover {
      scale: 1.05;
      filter: brightness(1.1);
    }
  }

  .imageBox {
    width: 100%;
    height: 200px;
    overflow: hidden;
  }
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const extractImage = (data) => {
  const contentText = data?.content;
  const imgRegex = /<img[^>]+src="([^">]+)"/;
  const match = contentText?.match(imgRegex);
  return match ? match?.[1] : null;
};

const extractExcerpt = (data) => {
  const contentText = data?.content;
  const cleanedContent = contentText?.replace(/<[^>]*>/g, "");
  return cleanedContent?.substring(0, 200) + "...";
};

async function getMediumPosts() {
  const proxyUrl = `${PROXY_URL}${encodeURIComponent(BLOG_URL)}`;

  try {
    const response = await fetch(proxyUrl);
    if (!response.ok) throw new Error("Proxy down");

    const data = await response.json();
    return data.items; // This will be an array of your blog posts
  } catch (error) {
    console.error("Medium feed failed:", error);
    return []; // Return empty array so your UI doesn't crash
  }
}
